import { UsersTable } from './users.table';
import { PermissionsTable } from './permissions.table';

// Wrapper class
export class AuthDataContext {
	public static users: any = UsersTable.users;
	public static permissions = PermissionsTable.permissions;
}
